/* eslint-disable @typescript-eslint/no-magic-numbers */
import React from 'react';
import { Typography } from '@cp/ds/src/components/typography';
import { Stack } from '@cp/ds/src/components/stack';
import { ContentSkeleton } from '@cp/ds/src/components/contentSkeleton';
import { useIsMobile } from '@cp/ds/src/hooks/useIsMobile';
import { RoutedLink } from 'src/shared/ui/link';
import { CatalogBannerNoDoubtsProps } from './model';

export const CatalogBannerNoDoubts: React.FC<CatalogBannerNoDoubtsProps> = ({ careerId, careerDict }) => {
  const isMobile = useIsMobile();

  if (!careerDict) {
    return <ContentSkeleton blocks={1} />;
  }

  return (
    <Stack direction="column" sx={{ alignItems: 'center', textAlign: 'center', p: isMobile ? 2.5 : 4.5, px: isMobile ? 1.5 : undefined }}>
      <Typography variant="h5">
        Сомневаетесь приглашать {careerDict[careerId]?.translation.nameSingleAccusative ?? 'специалиста'} или нет?
      </Typography>
      <Typography sx={{ color: 'gray', my: 2 }} variant="caption">
        Не сомневайтесь. 95% наших клиентов рекомендуют нас своим друзьям.
      </Typography>
      <Typography variant="caption bold">
        Все {careerDict[careerId]?.translation.namePlural ?? 'специалисты'} проверены{' '}
        <RoutedLink color="pink" href="https://spectrumdata.ru/" sx={{ display: 'inline', font: 'inherit' }}>
          тут
        </RoutedLink>
      </Typography>
    </Stack>
  );
};
